import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { integrationsApi } from 'src/services';

type SyncEhrAppointmentsByOrgPayload = {
  org_uuid: string;
  ehr: string;
};

type SyncEhrAppointmentsByOrgResponse = {
  message: string;
  code: number;
  success: boolean;
};

export const useSyncEhrAppointmentsByOrg = (
  options?: UseMutationOptions<
    SyncEhrAppointmentsByOrgResponse,
    unknown,
    SyncEhrAppointmentsByOrgPayload
  >
) => {
  return useMutation<
    SyncEhrAppointmentsByOrgResponse,
    unknown,
    SyncEhrAppointmentsByOrgPayload
  >({
    mutationFn: (payload) =>
      integrationsApi
        .post('/ehr/sync-appointments-by-org', payload)
        .then((res) => res.data),
    ...options,
  });
};
